<template>
	<div class="bar-info-actions">
		<div class="bar-info-actions-container">
			<info-action
				v-for="action in actions"
				:key="action.id"
				:action="action"
			></info-action>
		</div>
	</div>
</template>

<script>
	import infoAction from '@/components/market-place/info-action';

	export default {
		name: 'bar-info-actions',
		components: {
			infoAction,
		},
		props: {
			actions: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.bar-info-actions {
		background-color: color(white);
		padding: 19px 15px 25px;

		@media (min-width: 1280px) {
			padding: 19px 0px 25px;
		}

		&-container {
			align-items: flex-start;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
			margin: 0 auto;
			max-width: 1200px;

			@media (min-width: 936px) {
				align-items: center;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/bar-info-actions.vue